import { InjectionToken } from '@angular/core';
import { IBookmarkService } from './bookmark-service.interface';

export const BOOKMARK_SERVICE =
  new InjectionToken<IBookmarkService>('BOOKMARK_SERVICE');
